import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('IN_TUNE_REPORT')

